import { render, staticRenderFns } from "./SavolJavob.vue?vue&type=template&id=1c6fed24&scoped=true&"
import script from "./SavolJavob.vue?vue&type=script&lang=js&"
export * from "./SavolJavob.vue?vue&type=script&lang=js&"
import style0 from "./SavolJavob.vue?vue&type=style&index=0&id=1c6fed24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6fed24",
  null
  
)

export default component.exports